var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowGroups(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4821_150748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.875H11.25C12.2854 1.875 13.125 2.71465 13.125 3.75V7.5C13.125 8.53535 12.2854 9.375 11.25 9.375H7.5C6.46465 9.375 5.625 8.53535 5.625 7.5V3.75C5.625 2.71465 6.46465 1.875 7.5 1.875Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91011 11.25H11.25C12.2854 11.25 13.125 12.0896 13.125 13.125V14.2013L8.91011 11.25Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72824 12.51C5.66135 12.7026 5.625 12.9096 5.625 13.125V16.875C5.625 17.9104 6.46465 18.75 7.5 18.75H11.25C12.0321 18.75 12.7025 18.2709 12.9837 17.5903L5.72824 12.51Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7396 20.9204C17.2196 21.2537 16.875 21.8367 16.875 22.5V26.25C16.875 27.2854 17.7146 28.125 18.75 28.125H22.5C23.5354 28.125 24.375 27.2854 24.375 26.25V25.5666L17.7396 20.9204Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3178 22.0386C24.1121 21.2263 23.3761 20.625 22.5 20.625H22.299L24.3178 22.0386Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6212 18.75H22.5C23.5354 18.75 24.375 17.9104 24.375 16.875V13.125C24.375 12.0896 23.5354 11.25 22.5 11.25H18.75C17.7146 11.25 16.875 12.0896 16.875 13.125V16.8271L19.6212 18.75Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 20.625H11.25C12.2854 20.625 13.125 21.4646 13.125 22.5V26.25C13.125 27.2854 12.2854 28.125 11.25 28.125H7.5C6.46465 28.125 5.625 27.2854 5.625 26.25V22.5C5.625 21.4646 6.46465 20.625 7.5 20.625Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 1.875H22.5C23.5354 1.875 24.375 2.71465 24.375 3.75V7.5C24.375 8.53535 23.5354 9.375 22.5 9.375H18.75C17.7146 9.375 16.875 8.53535 16.875 7.5V3.75C16.875 2.71465 17.7146 1.875 18.75 1.875Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8296 24.6456L0.296287 5.22292C-0.0299568 4.99133 -0.106861 4.53886 0.124706 4.21216L0.96386 3.02937C1.19543 2.70267 1.64835 2.62575 1.97507 2.85777L29.5084 22.2805C29.8347 22.5121 29.9116 22.9645 29.68 23.2912L28.8408 24.474C28.6093 24.8007 28.1563 24.8772 27.8296 24.6456Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4821_150748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowGroups);
export default __webpack_public_path__ + "static/media/show_groups.e7a421c933e0e62d1ccbfb3fc3a4c068.svg";
export { ForwardRef as ReactComponent };